import { useBackdropContext } from '../../../../../../../context/backdrop';
import { OptimizerModeInternal } from '../../../../../../../data-access/gql-types/graphql';
import { OptimizerModeInternalRequest } from '../../../../../types/graphql-rest-converter';
import { useOptimizerSetMode, useOptimizerSetTestModeLoad } from '../../../../../api/optimizer/optimizer.hooks';
import { ChannelType } from '../../../../../types';
import { useOptimizerConfigurationContext } from '../../context/configuration-context';
import { TestFormBody } from '../types';

export const useOptimizerTest = (channel: ChannelType) => {
  const { mutate: setMode } = useOptimizerSetMode();
  const { mutate: setModeLoad } = useOptimizerSetTestModeLoad();
  const { turnOnBackdrop, turnOffBackdrop } = useBackdropContext();
  const { clearErrors } = useOptimizerConfigurationContext();

  const submitConfiguration = (mode: OptimizerModeInternal, formValues: TestFormBody) => {
    clearErrors();
    turnOnBackdrop();

    setMode(
      {
        deviceId: channel.deviceId,
        channelId: channel.id,
        mode: OptimizerModeInternalRequest[mode],
      },
      {
        onSuccess: ({ data }) => {
          if (data) {
            turnOnBackdrop();

            setModeLoad(
              {
                deviceId: channel.deviceId,
                channelId: channel.id,
                scr: [formValues.phase1, formValues.phase2, formValues.phase3],
              },
              {
                onSuccess: () => {
                  turnOffBackdrop();
                },
              },
            );
          } else {
            turnOffBackdrop();
          }
        },
      },
    );
  };

  return {
    submitConfiguration,
  };
};
